/**
 * Native bridge communication utilities for iOS/Android.
 */

export const sendMessageToApp = (message) => {
  // iOS
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.reactNative) {
    window.webkit.messageHandlers.reactNative.postMessage(message);
  }
  // Android
  else if (window.android) {
    window.android.postMessage(message);
  }
};

// 邮件入口统一发 JSON 消息：{"action":"email us","email":"xxx@xxx.com"}
// 原生按 JSON 解析，action 匹配 "email us"，email 为目标邮箱（缺省时原生用默认邮箱）
export const sendEmailToApp = (email) => {
  const payload = email ? { action: "email us", email } : { action: "email us" };
  sendMessageToApp(JSON.stringify(payload));
};

export const sendLinkToApp = (url) => {
  if (url.startsWith("mailto:")) {
    // 去掉 mailto: 前缀和 ?subject=... 等查询参数，只保留邮箱地址
    const email = decodeURIComponent(url.slice("mailto:".length).split("?")[0]);
    sendEmailToApp(email);
    return;
  }
  sendMessageToApp("href:" + url);
};
